module.exports = __webpack_public_path__ + "static/media/location-ff7d77.287c63a0.svg";